import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ErpTrackingInitialState, ErpTrackingItemLoad } from './erp-tracking-item.actions';
import { SetInitialStateFacade } from '../../../../common';
import { ErpTrackingItemState } from './erp-tracking-item.state';
import { DeliveryNoteErpView, ErpTrackingPayload } from '../models/erp-tracking.model';

@Injectable({ providedIn: 'root' })
export class ErpTrackingItemFacade implements SetInitialStateFacade {
  deliveryNote$: Observable<DeliveryNoteErpView> = this.store.select(ErpTrackingItemState.getItem);
  loaded$: Observable<boolean> = this.store.select(ErpTrackingItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll({ deliveryNoteNumber, orderNumber, salesOrganization }: ErpTrackingPayload): void {
    this.store.dispatch(new ErpTrackingItemLoad({ deliveryNoteNumber, orderNumber, salesOrganization }));
  }

  setInitialState(): void {
    this.store.dispatch(new ErpTrackingInitialState());
  }
}
